import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const PaymentActiveOpenBankInfoBoleto = (): ReactNode => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Typography
        variant={'body1'}
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
          textAlign: 'center',
        }}
      >
        {t(
          'Copy the Barcode, open your bank app and pay via Boleto Copy and Paste',
        )}
      </Typography>
      <Typography
        variant={'body1'}
        sx={{
          display: 'none',
          '@media (min-width: 600px)': {
            display: 'block',
          },
          textAlign: 'center',
        }}
      >
        {t(
          "Open your bank's app, scan the image or copy and paste the Barcode",
        )}
      </Typography>
    </Stack>
  );
};

export default PaymentActiveOpenBankInfoBoleto;
